import profile from '@/store/modules/settings/modules/profile';

export default {
  namespaced: true,
  modules: {profile: profile}
};

